module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s3-f3a9a966ae039dbb6ab5fe0d99b03a50.svg";